/**
 * Hand a fetched binary body to the browser as a file download (TMMAPP-0005): an object URL on a
 * hidden `<a download>`, clicked, then revoked. The bearer-only transport rules out a plain link
 * to the endpoint (no cookie carries the session), so every export comes through `download()`.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  try {
    anchor.click();
  } finally {
    anchor.remove();
    URL.revokeObjectURL(url);
  }
}
